<template>
  <div class="recommend-items-base other-setitems">
    <h4><img src="/static/img/yearluck/y2020/titlelabel/other_set_menu.svg"></h4>
    <template v-for="(item, index) in itemListMod">
      <article-card
        :key="index"
        :tgt-item="item"
        @detailBtnClick="onDetailBtnClick(index)"
      ></article-card>
    </template>
  </div>
</template>

<script>
import ArticleCard from "@/utvStore/components/YearLuck/y2020/partials/articleCard";

export default {
  name: "otherSetItems",
  components: { ArticleCard },
  data() {
    return {
      targetIdx: -1,
      targetDetailData: {}
    }
  },
  props: {
    itemList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    itemListMod() {
      return this.itemList
    }
  },
  methods: {
    onDetailBtnClick(idx){
      this.targetIdx = idx
      this.targetDetailData = this.itemList[idx]
      this.$emit('onDetailBtnClick', idx)
      /*
      if(this.targetDetailData.linkUrl != null && this.targetDetailData.linkUrl.length > 0 ){
        location.href = this.targetDetailData.linkUrl
      } else {
        this.$nextTick(()=>{
          //
          this.isDetailDialogOpen = true
        })
      }
       */
    }
  }
}</script>

<style scoped lang="scss">
.recommend-items-base {
  h4 {
    img {
      display: block;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/partials/otherSetItems.vue